/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_Events_DescriptionInputs */

const en_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize events for your community`)
};

const de_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisiere Events für deine Community`)
};

const es_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organiza eventos para fortalecer tu comunidad`)
};

const fr_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisez des évènements pour renforcer votre communauté`)
};

const nl_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organiseer Events voor je community`)
};

const it_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizza eventi per la tua comunità`)
};

const pt_br2_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize eventos para sua comunidade`)
};

const pl_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizuj wydarzenia dla swojej społeczności`)
};

const hu_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szervezzen eseményeket közösségének`)
};

const ro_admin_dashboard_empty_events_description = /** @type {(inputs: Admin_Dashboard_Empty_Events_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizati evenimente pentru comunitatea dumneavoastra`)
};

/**
* | output |
* | --- |
* | "Organize events for your community" |
*
* @param {Admin_Dashboard_Empty_Events_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_events_description = /** @type {((inputs?: Admin_Dashboard_Empty_Events_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_Events_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_events_description(inputs)
	if (locale === "de") return de_admin_dashboard_empty_events_description(inputs)
	if (locale === "es") return es_admin_dashboard_empty_events_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_events_description(inputs)
	if (locale === "nl") return nl_admin_dashboard_empty_events_description(inputs)
	if (locale === "it") return it_admin_dashboard_empty_events_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_events_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_events_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_events_description(inputs)
	return ro_admin_dashboard_empty_events_description(inputs)
});
export { admin_dashboard_empty_events_description as "admin.dashboard.empty_events_description" }